import React from 'react';
import propTypes from 'prop-types';

export default function Enum(props) {
    let vname = props.option[props.value] ?? props.value;
    vname = vname === '' ? props.value : vname;
    const lineRender = props.colors && props.colors[props.value] ? (
        <span className='colorList' style={{backgroundColor: props.colors[props.value]}}> </span>
    ) : (
        <span
            className={props.bcColor ? 'listBcColor' : ''}
            style={props.bcColor ? {backgroundColor: props.bcColor, color: '#FFF'} : {}}
            title={vname}
            href={'#/admin/SystemSettings'}
        >
            {vname}
        </span>
    );

    return (
        <div
            className={'newListViewLine ' + props.extraClass}
            style={props.bcColor ? {color: '#FFF'} : {}}
            onClick={props.onClick}
        >
            {lineRender}
        </div>
    );
}

Enum.propTypes = {
    modul: propTypes.string,
    option: propTypes.object,
    value: propTypes.string,
    colors: propTypes.any,
    bcColor: propTypes.string,
    onClick: propTypes.func,
    extraClass: propTypes.string,
};
